/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_TInputs */

const en_mk_tut_ws_t = /** @type {(inputs: Mk_Tut_Ws_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating a workspace and choosing divisions`)
};

const id_mk_tut_ws_t = /** @type {(inputs: Mk_Tut_Ws_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat workspace dan memilih divisi`)
};

/**
* | output |
* | --- |
* | "Creating a workspace and choosing divisions" |
*
* @param {Mk_Tut_Ws_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_t = /** @type {((inputs?: Mk_Tut_Ws_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_t(inputs)
	return en_mk_tut_ws_t(inputs)
});